export enum LiquidationRouteNames {
  LiquidationLandingPage = 'LiquidationLandingPage',
  LiquidationSourcePage = 'LiquidationSourcePage',
  LiquidationDestinationPage = 'LiquidationDestinationPage',
  LiquidationTaxInformationPage = 'LiquidationTaxInformationPage',
  LiquidationConfirmPage = 'LiquidationConfirmPage',
  LiquidationSuccessPage = 'LiquidationSuccessPage',
}
